module.exports = __webpack_public_path__ + "img/1691026744171-image.jpg.29d1887b.webp";